import "bootstrap/dist/css/bootstrap.css";
import "font-awesome/css/font-awesome.css";
import "react-bootstrap-table/css/react-bootstrap-table.css";
import "react-datetime/css/react-datetime.css";
import "react-select/dist/react-select.css";
import "./styles/reset.css";
import "./styles/shared.css";
import "./styles/admin.css";
import "./styles/admin-print.css";
import "./styles/public.css";
import "./styles/public-print.css";

global.Symbol = require("core-js/es6/symbol");
import "core-js";
import "whatwg-fetch";
import * as React from "react";
import * as ReactDOM from "react-dom";
import * as ReactGA from "react-ga";
import { Provider } from "react-redux";
import { Route } from "react-router";
import { ConnectedRouter } from "react-router-redux";
import { createBrowserHistory } from "history";

import { configureStore } from "./configure-store";
import Settings from "./settings";
import { AppState } from "../src/store";
import { App } from "../src/components/app";
import { unregister } from "./registerServiceWorker";
// import registerServiceWorker from "./registerServiceWorker";

unregister();

// Create browser history to use in the Redux store
const baseUrl = process.env.PUBLIC_URL as string;
const history = createBrowserHistory({ basename: baseUrl });

// Get the application-wide store instance, prepopulating with state from the server where available.
// window.REDUX_DATA is set in ./server/universal.tsx when performing SSR
const initialState = ((window as any).REDUX_DATA || (window as any).initialReduxState || (window as any).__INITIAL_STATE__) as AppState;
const store = configureStore(history, initialState);

// Setup api client creds
const clientId = Settings.ClientId;
const clientSecret = Settings.ClientSecret;

// Setup Google Analytics
ReactGA.initialize("UA-28231232-5", {
    // debug: true,
    titleCase: false,
  });

// This code starts up the React app when it runs in a browser. It sets up the routing configuration
// and injects the app into a DOM element.
ReactDOM.hydrate(
    <Provider store={ store }>
        <ConnectedRouter history={ history }>
            <Route path="/" render={(routerProps) => <App {...routerProps} clientId={clientId} clientSecret={clientSecret} />} />
        </ConnectedRouter>
    </Provider>,
    document.getElementById("shell") as HTMLElement,
);

// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.tsx